import * as z from "../../..";
import * as ui from "../../../../app/core/ui";

var addGroupView = (groupButtonId: number) =>
    new ui.Container({
        id: `GroupContainer_${groupButtonId}`,
        style: "display: flow;",
        components: [
            new ui.Container({
                id: "ButtonsContainer",
                style: "display: flex; margin-bottom: 5px;",
                components: [
                    new ui.Toggle({
                        id: `AndOrToggle${groupButtonId}`,
                        labelTrue: "And",
                        labelFalse: "Or",
                        bindValue: "AndOrFilter"
                    }),
                    new ui.HTML({
                        HTML: `
                        <span id='add-expression-button${groupButtonId}' class='action-button' style='margin-right: 5px;'>
                            <span class='k-icon k-i-filter-add-expression' style='margin-right: 5px; margin-top: 5px; margin-left: 3px'></span>
                            <span class='user-grid-tab-button-label'>${z.ll("AddExpression")}</span>
                        </span>`,
                        id: "AddExpression",
                    }),
                    new ui.HTML({
                        HTML: `
                        <span id='add-group-button${groupButtonId}' class='action-button'>
                            <span class='k-icon k-i-filter-add-expression' style='margin-right: 5px; margin-top: 5px; margin-left: 3px'></span>
                            <span class='user-grid-tab-button-label'>${z.ll("AddGroup")}</span>
                        </span>`,
                        id: "AddGroup"
                    }),
                    new ui.HTML({
                        HTML: groupButtonId == 0 ? "" : `<a id='RemoveGroup${groupButtonId}' class='mar-t-10 mar-l-10 close'></a>`
                    })
                ]
                }),
                new ui.Container({
                    id: `ExpressionContainer_${groupButtonId}`,
                    components:[]
                })
        ]
    });

export default addGroupView;
